import React from "react";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import {
  Button,
  Checkbox,
  ThreeStateValue,
  Icon,
  Tooltip,
  WithTooltip,
  Input,
  Popup,
  WithPopup,
  Dropdown,
  DropdownOption,
  ThemeProvider,
  ToggleSwitch,
  Dialog,
} from "@abb/abb-common-ux-react";
import {
  ABB_PAUSE,
  ABB_CLOSE,
  ABB_REFRESH,
} from "../../utilities/IconConstants";
import * as CONSTANTS from "../../utilities/Constants";
import * as ICONCONSTANTS from "../../utilities/IconConstants";
import { Translation } from "react-i18next";
import { Status } from "../../models/sample/Status";
import { BackupStatus } from "../../models/backupAndRestore/Status";
import { initial } from "lodash";
import moment from "moment";
import { InputType } from "../../models/shared/IEnumTypes";
import Authorize from "../../utilities/Authorize";
import History from "../../utilities/History";

interface ITableValues {
  authKey?: string;
  list: any[];
  onSearchHandler?: any;
  searchValue?: any;
  sortOrder?: any;
  sortValue?: any;
  onSortHandler?: any;
  dropDownData?: any[];
  columns: IColumnHeaderData[];
  name?: string;
  labelNumber?: number;
  select: boolean;
  isFixedColumn: boolean;
  delete?: boolean;
  isEditAction?: boolean;
  isDisableAction?: boolean;
  isEnableAction?: boolean;
  isDeleteAction?: boolean;
  isAssociation?: boolean;
  EnableAction?: (data: any) => void;
  DisableAction?: (data: any) => void;
  DeleteAction?: (data: any) => void;
  associationAction?: () => void;
  associationText?: string;
  noDataIndication?: string;
  selected?: any[];
  cellEdit?: (e: any, rowIndex: number, colIndex: number) => void;
  cellBlurEdit?: (e: any, rowIndex: number, colIndex: number) => void;
  cellDelete?: (data: any, rowIndex: number) => void;
  handleOnSelect?: (row: any, isSelect: boolean) => void;
  handleOnSelectAll?: (isSelect: boolean, rows: any) => void;
  isEditable?: boolean;
  isTitle?: React.ReactNode;
  moduleName?: string;
  tableStyle?: string;
  setColor?: boolean;
  isTableShow?: boolean;
  isSecondaryTitle?: React.ReactNode;
  isRowClass?: string;
  form?: boolean;
  view?: boolean;
  viewAllPage?: boolean;
  errRowIndex?: any[];
  onRestoreBackup?: (data: any, rowIndex: number) => void;
  onPauseRestore?: (data: any, rowIndex: number) => void;
  onCancelRestore?: (data: any, rowIndex: number) => void;
  onDeleteBackup?: (data: any) => void;
  isRestoreBackup?: boolean;
  selectedRowNo?: number;
  setPropertiesOrderNo?: (rowData: any[]) => void;
  selectedRowForDelete?: any[];
  isEditSampleAction?: boolean;
  editHandler?: (data: any) => any;
  isSingleRowChecked?: boolean;
  isMultipleRowChecked?: boolean;
  singleRowCheckedHandler?: (data: any) => any;
  sampleExportHandler?: (data: any) => any;
  sampleDownloadHandler?: (data: any) => any;
  measurementHandler?: (data: any, multipleData: any) => any;
  remeasureMeasurementHandler?: (data: any, multipleData: any) => any;
  measurementApproveHandler?: (data: any, multipleData: any) => any;
  measurementRejectHandler?: (data: any, multipleData: any) => any;
  multipleRowCheckedHandler?: (data: any) => any;
  clearFilter?: () => void;
  configDelete?: number;
  disableCreateButton?: (value: boolean) => void;
  redirectBaseUrl?: string;
  deleteModuleName?: string;
}

interface ITableState {
  checked: any;
  dropDownList: any[];
  indeterminate: number;
  dropDownValue: any;
  checkedData: any[];
  enableButton: boolean;
  disableButton: boolean;
  loadingAction: boolean;
  isDisableDeleteButton: boolean;
  row: any;
  startIndex: number;
  targetIndex: number;
  orderProperties: any[];
  isShowWarning: boolean;
  isToggleEnable: boolean;
  deleteModalVisible: boolean;
}

export default class AbbTableComponent extends React.Component<
  ITableValues,
  ITableState
> {
  private _selected: boolean = false;
  private _dropDownList = [
    { label: "All", value: "1" },
    { label: "Disabled", value: "2" },
    { label: "Enabled", value: "3" },
  ];
  onEditClick: (event: any, customData: any) => void;
  private _currentCheckedRow: any;
  constructor(props: ITableValues) {
    super(props);
    this.state = {
      checked: false,
      dropDownList: this._dropDownList,
      indeterminate: 1,
      checkedData: [],
      enableButton: true,
      disableButton: true,
      loadingAction: false,
      isDisableDeleteButton: true,
      dropDownValue: [{ label: "All", value: "1" }],
      row: null,
      startIndex: -1,
      targetIndex: -1,
      orderProperties: [],
      isShowWarning: false,
      isToggleEnable: false,
      deleteModalVisible: false
    };
  }

  public static defaultProps = {
    isTableShow: true,
  };

  componentDidMount() {
    if (this.props.select) {
      this.props.columns.unshift({ dataField: "checkbox", text: "" });
    }
    if (this.props.delete) {
      this.props.columns.push({ dataField: "delete", text: "" });
    }
  }

  componentDidUpdate(prevProps: any, prevState: any) {        
    if (this.props.selectedRowForDelete !== prevProps.selectedRowForDelete) {
      if (this.props.selectedRowForDelete.length === 0) {
        this.setState({
          checked: ThreeStateValue.Unchecked,
          checkedData: [],
          isDisableDeleteButton: true,
        });
      }
    }
    if (this.props.dropDownData?.length !== prevProps.dropDownData?.length) {
      if (this.props.dropDownData.length) {
        const dropDown: any = [{ label: "All", value: "1" }];
        this.props.dropDownData.forEach((item: any) => {
          dropDown.push({ label: item.name, value: item.id });
          this.setState({
            dropDownList: [...dropDown],
          });
        });
      }
    }
    if (this.props.list !== prevProps.list) {
      if (this.state.checked == 1 && this.state.checkedData.length) {
        this.setState({
          enableButton: true,
          disableButton: true,
        });
      }
      if (this.state.checked == 2) {
        this.setState({
          checked: ThreeStateValue.Checked,
          checkedData: this.props.list,
        });
      }      
    }

    if (
      this.props.configDelete &&
      this.props.configDelete !== prevProps.configDelete
    ) {
      this.setState({
        checked: ThreeStateValue.Unchecked,
        checkedData: [],
      });
    }
  }

  public start = (event: any) => {
    let draggedRow = event.target.closest("tr");
    let rowNumber = draggedRow.rowIndex;

    this.setState({ row: event.target, startIndex: rowNumber });
  };

  public dragover = (event: any) => {
    var e = event;
    e.preventDefault();

    let children = Array.from(e.target.parentNode.parentNode.children);
    if (
      children.indexOf(e.target.parentNode) > children.indexOf(this.state.row)
    ) {
      e.target.parentNode.after(this.state.row);
    } else {
      e.target.parentNode.before(this.state.row);
    }
  };

  public onDrop = (ev: any) => {
    ev.preventDefault();
    if (ev.stopPropagation) {
      ev.stopPropagation();
    }
    var table = document.getElementsByTagName("table")[0];
    var rows = Array.from(table.rows);
    this.props.setPropertiesOrderNo(rows);
  };

  public onToggleChange = (value: any) => {
    this.setState({
      isToggleEnable: !this.state.isToggleEnable,
      dropDownValue: [{ label: "All", value: "1" }],
    });
    if (this.state.isToggleEnable) {
      this.props.clearFilter();
      this.props.singleRowCheckedHandler(false);
      this.props.multipleRowCheckedHandler(false);
    }
  };

  public onSearchHandler = (name: any, eventsValue: any, index: any) => {    
    if (eventsValue.length >= CONSTANTS.SEARCH_LENGTH || eventsValue.length === 0) {
      this.setState({
        checked: ThreeStateValue.Unchecked,
        isDisableDeleteButton: true,
        checkedData: [],
      });
    }
    this.props.onSearchHandler(name, eventsValue);
  };

  public onDropDownHandler = (name: any, item: any): any => {    
    this.setState({
      checked: ThreeStateValue.Unchecked,
      isDisableDeleteButton: true,
      checkedData: [],
      dropDownValue: [{ label: item[0].label, value: item[0].value }],
    });
    if (name === "Directions") {
      item[0].value === "1"
        ? this.props.onSearchHandler(name, "all", "all")
        : this.props.onSearchHandler(name, item[0].value);
    } else {
      this.props.onSearchHandler(name, item[0].label, item[0].value);
    }
  };
  renderTableHeadData() {
    return (this.props.columns || []).map((key, index) => {
      if (key.dataField === "checkbox") {
        return (
          <Translation>
            {(t) => (
              <React.Fragment>
                <th
                  style={{
                    width: 50,
                    padding: 1,
                    zIndex: 9999,
                    borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
                  }}
                  key={index}
                >
                  {this.props.moduleName === CONSTANTS.ALL_SAMPLES ||
                    this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY ? (
                    <Checkbox
                      sizeClass="small"
                      value={this.state.checked}
                      onChange={this.selectAllCheckbox}
                      allowIndeterminate={true}
                    />
                  ) : null}
                </th>
              </React.Fragment>
            )}
          </Translation>
        );
      } else if (key.dataField === "filterIcon" && !this.state.isToggleEnable) {
        return (
          <th
            className="delete-icon"
            key={index}
            style={{ borderBottom: "2px solid rgba(0, 0, 0, 0.1)" }}
          >
            {" "}
            <Authorize scopes={[`${this.props.authKey}:ViewAllFilters`]}>
            <Icon
              className="float-right"
              name="abb/filter"
              sizeClass="small"
              onClick={(value): any => this.onToggleChange(value)}
            /></Authorize>{" "}
          </th>
        );
      } else if (key.dataField === "filterIcon" && this.state.isToggleEnable) {
        return (
          <th
            className="delete-icon"
            key={index}
            style={{
              borderBottom: "2px solid rgba(0, 0, 0, 0.1)",
              padding: "0px",
            }}
          >
            {" "}
            <Authorize scopes={[`${this.props.authKey}:ViewAllFilters`]}>
            <Icon
              style={{
                background: "#BABABA",
                borderRadius: "50%",
                padding: "8px 10px",
              }}
              className="float-right"
              name="abb/filter"
              sizeClass="small"
              onClick={(value): any => this.onToggleChange(value)}
            /></Authorize>{" "}
          </th>
        );
      } else if (key.dataField === "delete") {
        return <th className="delete-icon" key={index}></th>;
      } else {
        return (
          <th
            key={index}
            style={{
              paddingLeft: "0px",
              zIndex: this.props.viewAllPage ? 999 : 0,
              borderBottom:
                this.props.sortValue === key.text &&
                  this.props.searchValue[index]?.sort
                  ? "2px solid #3366FF"
                  : "2px solid rgba(0, 0, 0, 0.1)",
            }}
            className={key.isFixed ? "abb-sticky-col row-data" : "row-data"}
          >
            {this.props &&
              this.props.searchValue &&
              this.props.searchValue[index]?.sort ? (
              <span
                className="cursor-pointer"
                style={{ paddingLeft: "10px" }}
                onClick={(e) =>
                  this.props.onSortHandler(
                    this.props.searchValue[index]?.key,
                    key.text,
                    this.props.sortValue === key.text
                      ? this.props.sortOrder === CONSTANTS.SORT_DESC_ORDER
                        ? CONSTANTS.SORT_ASC_ORDER
                        : CONSTANTS.SORT_DESC_ORDER
                      : CONSTANTS.SORT_DESC_ORDER
                  )
                }
              >
                {key.text}
              </span>
            ) : (
              <span style={{ paddingLeft: "10px" }}>{key.text}</span>
            )}
            {this.props.sortValue === key.text &&
              this.props.searchValue[index]?.sort ? (
              this.props.sortOrder === CONSTANTS.SORT_DESC_ORDER ? (
                <Icon
                  className="ml-1 cursor-pointer vertical-align-text-top"
                  name="abb/triangle-up"
                  sizeClass="small"
                  onClick={(e) =>
                    this.props.onSortHandler(
                      this.props.searchValue[index]?.key,
                      this.props.sortValue,
                      CONSTANTS.SORT_ASC_ORDER
                    )
                  }
                />
              ) : (
                <Icon
                  className="ml-1 cursor-pointer vertical-align-text-top"
                  name="abb/triangle-down"
                  sizeClass="small"
                  onClick={(e) =>
                    this.props.onSortHandler(
                      this.props.searchValue[index]?.key,
                      this.props.sortValue,
                      CONSTANTS.SORT_DESC_ORDER
                    )
                  }
                />
              )
            ) : null}
          </th>
        );
      }
    });
  }

  filterTableHeadData() {
    return (this.props.columns || []).map((key, index) => {
      if (key.dataField === "checkbox") {
        return (
          <td
            className="sticky-table"
            style={{ width: 50, padding: 1 }}
            key={index}
          ></td>
        );
      } else if (key.dataField === "filterIcon") {
        return (
          <td className="delete-icon sticky-table" key={index}>
            {" "}
            <Icon
              className="float-right mr-2"
              name="abb/close"
              sizeClass="small"
              onClick={(value): any => this.onToggleChange(value)}
            />{" "}
          </td>
        );
      } else if (key.dataField === "delete") {
        return <td className="delete-icon sticky-table" key={index}></td>;
      } else {
        return (
          <td className="sticky-table">
            {key.type === InputType.DROPDOWN ? (
              <Translation>
                {(t) => (
                  <Dropdown
                    placeholder={
                      CONSTANTS.LABEL_PICK + " " + CONSTANTS.LABEL_VALUE
                    }
                    value={this.state.dropDownValue}
                    onChange={(value): any =>
                      this.onDropDownHandler(
                        this.props.searchValue[index]?.key,
                        value
                      )
                    }
                    style={{ width: "10rem" }}
                  >
                    {this.state.dropDownList.map((o: any) => {
                      return (
                        <DropdownOption
                          key={o.value}
                          label={o.label}
                          value={o.value}
                        />
                      );
                    })}
                  </Dropdown>
                )}
              </Translation>
            ) : key.type === InputType.SEARCHBAR ? (
              <Translation>
                {(t) => (
                  <div className="text-center" style={{ width: "10rem" }}>
                    <Input
                      type="normal"
                      inputAttributes={{ autoFocus: "true" }}
                      id={key.text}
                      key={key.text}
                      dataType="text"
                      placeholder={t(CONSTANTS.LABEL_SEARCH)}
                      icon="abb/search"
                      value={this.props.searchValue[index]?.value}
                      onValueChange={(eventsValue) =>
                        this.onSearchHandler(
                          this.props.searchValue[index]?.key,
                          eventsValue,
                          index
                        )
                      }
                    />
                  </div>
                )}
              </Translation>
            ) : key.type === InputType.BLANK ? (
              <div style={{ visibility: "hidden" }}>
                <Input type="normal" dataType="text" />
              </div>
            ) : null}
          </td>
        );
      }
    });
  }

  private redirectSelectedSample = (searchName:string, id:any) =>{
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_INSTRUMENT){
      History.push(CONSTANTS.INSTRUMENT_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_PROPERTY){
      History.push(CONSTANTS.PROPERTY_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_BACKUP_AND_RESTORE){
      History.push(CONSTANTS.UTILITY_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_GRADE){
      History.push(CONSTANTS.GRADE_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_INSTRUMENTTYPE){
      History.push(CONSTANTS.INSTRUMENTTYPE_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_PRODUCT){
      History.push(CONSTANTS.PRODUCT_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_PROPERTY){
      History.push(CONSTANTS.PROPERTY_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_SCANNER){
      History.push(CONSTANTS.SCANNER_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_SOURCE){
      History.push(CONSTANTS.SOURCE_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_STATION){
      History.push(CONSTANTS.STATION_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_TESTPLAN){
      History.push(CONSTANTS.TESTPLAN_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
    if(this.props.redirectBaseUrl === CONSTANTS.MODULE_USERS){
      History.push(CONSTANTS.USER_INDEX_URL, {
        isSelectedLink: true,
        id: id,
        searchName: searchName
      });
    }
  }

  renderTableData() {
    return this.props.list?.map((data, rowIndex) => {
      return (
        <tr
          key={rowIndex}
          draggable={
            this.props.name ===
              CONSTANTS.MODULE_GRADE + " " + CONSTANTS.MODULE_PROPERTY
              ? "true"
              : "false"
          }
          onDragStart={(e) => this.start(e)}
          onDragOver={(e) => this.dragover(e)}
          onDrop={(e) => this.onDrop(e)}
          className={
            this.props.name ===
              CONSTANTS.MODULE_GRADE + " " + CONSTANTS.MODULE_PROPERTY
              ? "drag-row"
              : null
          }
        >
          {this.props.columns.map((val, colIndex) => {
            if (val.dataField === "checkbox") {
              this._selected = true;
              return (
                <td
                  className="select-box"
                  key={colIndex}
                  style={{ width: "2%" }}
                >
                  <Checkbox
                    sizeClass="small"
                    value={this.state.checkedData.includes(data)}
                    onChange={this.selectCheckbox}
                    // TODO: CHECK FOR DATA
                    data={data}
                  />
                </td>
              );
            } else if (val.dataField === "sigmapercent") {
              return (
                <td className="normal-row checkbox-sigma">
                  <Checkbox
                    sizeClass="small"
                    value={data.sigmaPercent ? data.sigmaPercent : false}
                    onChange={(e: any) =>
                      this.props.cellEdit("sigmaPercent", rowIndex, colIndex)
                    }
                    label="%"
                  />
                </td>
              );
            } else if (val.dataField === "filterIcon") {
              return <td className="selected"> &nbsp; </td>;
            } else if (val.dataField === "delete") {
              return (
                <td className="delete-icon deleted-last-col" key={colIndex}>
                  <Icon
                    onClick={() => this.props.cellDelete(data, rowIndex)}
                    name="abb/minus-in-circle"
                    sizeClass="medium"
                    color="blue"
                  />
                </td>
              );
            } else if (val.dataField === "restore") {
              return (
                <td className="normal-row-backup" key={colIndex}>
                  {data.status === BackupStatus.COMPLETED ? (
                    <Authorize scopes={[`${this.props.authKey}:Restore`]}>
                      {this.props.isRestoreBackup &&
                        rowIndex === this.props.selectedRowNo ? (
                        <Translation>
                          {(t) => (
                            <div className="float-right">
                              <Button
                                type="discreet-blue"
                                icon={ABB_REFRESH}
                                text={t(CONSTANTS.BUTTON_INPROGRESS)}
                                isLoading={true}
                                disabled={true}
                              />
                            </div>
                          )}
                        </Translation>
                      ) : (
                        <Translation>
                          {(t) => (
                            <div className="float-right">
                              <Button
                                type="discreet-blue"
                                text={t(CONSTANTS.BUTTON_RESTORE)}
                                onClick={() =>
                                  this.props.onRestoreBackup(data, rowIndex)
                                }
                              />
                            </div>
                          )}
                        </Translation>
                      )}
                    </Authorize>
                  ) : data.status === BackupStatus.CANCELLED ? (
                    <Translation>
                      {(t) => (
                        <div className="float-right">
                          <Button
                            text={t(CONSTANTS.BUTTON_RESTORE)}
                            disabled={true}
                            style={{ border: "0px solid #bababa" }}
                          />
                        </div>
                      )}
                    </Translation>
                  ) : data.status === BackupStatus.INPROGRESS ? (
                    <Translation>
                      {(t) => (
                        <div className="float-right">
                          <Button
                            icon={ABB_PAUSE}
                            type="discreet-blue"
                            onClick={() =>
                              this.props.onPauseRestore(data, rowIndex)
                            }
                            text={t(CONSTANTS.BUTTON_PAUSE)}
                          />
                          <Button
                            icon={ABB_CLOSE}
                            type="discreet-blue"
                            className="stop-color"
                            onClick={() =>
                              this.props.onCancelRestore(data, rowIndex)
                            }
                            text={t(CONSTANTS.BUTTON_CANCEL)}
                          />
                        </div>
                      )}
                    </Translation>
                  ) : null}
                </td>
              );
            } else if (val.dataField === "description") {
              return (
                <td className="normal-row" key={colIndex}>
                  <WithTooltip>
                    <div className="desc-width-20rem text-ellipsis">
                      {data.description}
                    </div>
                    <Tooltip className="pl-2 pr-2 pb-1 desc-tooltip">
                      <p>{data.description}</p>
                    </Tooltip>
                  </WithTooltip>
                </td>
              );
            } else {
              let classnames = "normal-row";
              if (this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY) {
                classnames = "normal-row-backup";
              }

              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              val.isFixed ? (classnames += " abb-sticky-col") : null;
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              this._selected ? (classnames = "selected") : null;
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              this.props.delete ? (classnames = "deleted") : null;

              if (val.dataField === "propertyName" 
              || val.dataField === "property.propertyNameDirection") {
                classnames += " word-wrap-table";
              }

              if(val.dataField === "message"){
                classnames += " word-wrap-message-table";
              }

              if(val.dataField === "exception"){
                classnames += " exception-log";
              }

              if (
                val.dataField.indexOf(".") !== -1 &&
                typeof data === "object"
              ) {
                const value = val.dataField.split(".");
                var result: any = data;
                value.forEach((element) => {
                  if (result[element]) {
                    result = result[element];
                  } else {
                    result = "";
                  }
                });
                return (
                  <td key={colIndex} className={classnames}>
                    {this.props.isEditable && val.isEditable ? (
                      <input
                        title="input"
                        className="table-input"
                        type="text"
                        name={val.dataField}
                        value={result}
                        maxLength={7}
                        style={
                          this.props.errRowIndex[0] === rowIndex &&
                            this.props.errRowIndex[1] === colIndex
                            ? { border: "1px solid red" }
                            : undefined
                        }
                        onChange={(e: any) =>
                          this.props.cellEdit(e, rowIndex, colIndex)
                        }
                        onBlur={(e: any) =>
                          this.props.cellBlurEdit(e, rowIndex, colIndex)
                        }
                      />
                    ) : (
                      <span className="view-all-overflow-hidden">{result}</span>
                    )}
                  </td>
                );
              } else {
                let color = "black";
                if (data.name === "Alarm Limit1") {
                  color = CONSTANTS.ALARM_LIMIT1_COLOR;
                } else if (data.name === "Alarm Limit2") {
                  color = CONSTANTS.ALARM_LIMIT2_COLOR;
                } else if (data.name === "Reject Limit") {
                  color = "red";
                }
                return (
                  <Translation>
                    {(t) => (
                      <td
                        key={colIndex}
                        className={`${data.status?.name === Status.MEASURED ||
                          data.status?.name === Status.MEASURING ||
                          data.status?.name === Status.STOPPED ||
                          data.status?.name === Status.PAUSED ||
                          data.status?.name === Status.APPROVED ||
                          data.status?.name === Status.REJECTED ||
                          data.status?.name === Status.COMPLETED
                          ? "normal-row-status"
                          : data.status?.name === Status.NOTMEASURED
                            ? "normal-row-normalstatus"
                            : classnames
                          } ${data.status?.name === Status.MEASURING ||
                            data.status?.name === Status.STOPPED ||
                            data.status?.name === Status.PAUSED
                            ? "measuredState"
                            : data.status?.name === Status.APPROVED
                              ? "approvedState"
                              : data.status?.name === Status.REJECTED
                                ? "rejectedState"
                                : data.status?.name === Status.MEASURED
                                  ? "completedState"
                                  : null
                          }`}
                        style={{ width: val.style?.width }}
                      >
                        {this.props.isEditable && val.isEditable ? (
                          <input
                            className="table-input"
                            type="text"
                            name={val.dataField}
                            value={data[val.dataField]}
                            maxLength={7}
                            onChange={(e: any) =>
                              this.props.cellEdit(e, rowIndex, colIndex)
                            }
                            onBlur={(e: any) =>
                              this.props.cellBlurEdit(e, rowIndex, colIndex)
                            }
                          />
                        ) : val.dataField === "value" && this.props.setColor ? (
                          <span style={{ color }}>{data[val.dataField]}</span>
                        ) : val.dataField === "date" &&
                          this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY ? (
                          moment(data["dateTime"]).format("MM/D/YYYY")
                        ) : val.dataField === "time" &&
                          this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY ? (
                          moment(data["dateTime"]).format("h:mm a")
                        ) : val.dataField === "status" &&
                          this.props.isRestoreBackup &&
                          rowIndex === this.props.selectedRowNo ? (
                          <span>{t(CONSTANTS.BUTTON_INPROGRESS)}</span>
                        ) : val.dataField === "ipAddress" &&
                          this.props.moduleName ===
                          CONSTANTS.MODULE_INSTRUMENT ? (
                          data["connectionType"] !== "Network Sharing" ? (
                            data["ipAddress"]
                          ) : (
                            data["directory"]
                          )
                        ) :  ((val.dataField === "name" || val.dataField === "firstName") && 
                          this.props.redirectBaseUrl && this.props.redirectBaseUrl !== 
                          CONSTANTS.MODULE_BACKUP_AND_RESTORE && data.state !== "Disabled") ? (
                          <span className="view-all-point-samplename view-all-overflow-hidden"
                           onClick={()=>this.redirectSelectedSample(data[val.dataField], data.id)}>
                            {data[val.dataField]}</span>) : (
                          <span className="view-all-overflow-hidden">{data[val.dataField]}</span>
                        )}
                      </td>
                    )}
                  </Translation>
                );
              }
            }
          })}
        </tr>
      );
    });
  }

  public selectCheckbox = (data: any) => {
    if (this.state.checkedData.includes(data)) {
      const checkedData = this.state.checkedData.filter((d) =>
        this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY
          ? d.name !== data.name
          : d.id !== data.id
      );
      if (this.props.moduleName === CONSTANTS.ALL_SAMPLES) {
        this._currentCheckedRow = data;
        this.checkSampleStatusForDelete(checkedData);
      }
      if (this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY) {
        this.enableBackupSummaryDelete(checkedData);
      }

      this.setState(
        {
          checkedData,
        },
        () => {
          if (checkedData.length == 1 && checkedData[0].isEnabled) {
            this.setState({
              enableButton: false,
              disableButton: true,
            });
          } else if (checkedData.length == 1 && !checkedData[0].isEnabled) {
            this.setState({
              disableButton: false,
              enableButton: true,
            });
          }
          if (
            this.state.checkedData.length > 1 &&
            this.props.list.length <= this.state.checkedData.length
          ) {
            this.setState({
              checked: ThreeStateValue.Checked,
            });
          } else if (this.state.checkedData.length <= 0) {
            this.setState({
              checked: ThreeStateValue.Unchecked,
              disableButton: true,
              enableButton: true,
            });
          } else {
            this.setState({
              checked: ThreeStateValue.Indeterminate,
            });
          }
          if (this.state.checkedData.length > 1) {
            this.setState({
              disableButton: false,
              enableButton: false,
            });
          }
          if (this.props.moduleName === CONSTANTS.ALL_SAMPLES) {
            this.onChangeHandler();
          }
        }
      );
    } else {
      if (this.props.moduleName === CONSTANTS.ALL_SAMPLES) {
        this._currentCheckedRow = data;
        const checkedData = this.state.checkedData.concat(data);
        this.checkSampleStatusForDelete(checkedData);
      }
      if (this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY) {
        const checkedData = this.state.checkedData.concat(data);
        this.enableBackupSummaryDelete(checkedData);
      }

      this.setState(
        {
          checkedData: this.state.checkedData.concat(data),
        },
        () => {
          if (data.isEnabled) {
            this.setState({
              enableButton: false,
              disableButton: true,
            });
          } else if (data.isEnabled === false) {
            this.setState({
              disableButton: false,
              enableButton: true,
            });
          }
          if (
            this.state.checkedData.length > 1 &&
            this.props.list.length <= this.state.checkedData.length
          ) {
            this.setState({
              checked: ThreeStateValue.Checked,
              disableButton: false,
              enableButton: false,
            });
          } else if (this.state.checkedData.length <= 0) {
            this.setState({ checked: ThreeStateValue.Unchecked });
          } else {
            this.setState({
              checked: ThreeStateValue.Indeterminate,
            });
          }
          if (this.state.checkedData.length > 1) {
            this.setState({
              disableButton: false,
              enableButton: false,
            });
          }
          if (this.props.moduleName === CONSTANTS.ALL_SAMPLES) {
            this.onChangeHandler();
          }
        }
      );
    }
  };

  public onChangeHandler = () => {
    if (this.state.checkedData.length == 0) {
      this.props.singleRowCheckedHandler(false);
      this.props.multipleRowCheckedHandler(false);
    }
    if (this.state.checkedData.length == 1) {
      this.props.singleRowCheckedHandler(true);
      this.props.multipleRowCheckedHandler(false);
    }
    if (this.state.checkedData.length > 1) {
      this.props.singleRowCheckedHandler(false);
      this.props.multipleRowCheckedHandler(true);
    }
  };

  public selectAllCheckbox = () => {      
    if (this.state.checked === ThreeStateValue.Checked) {
      this.setState({
        checked: ThreeStateValue.Unchecked,
        checkedData: [],
        isShowWarning: false,
        isDisableDeleteButton: true,
      });
      if (this.props.moduleName === CONSTANTS.ALL_SAMPLES) {
        this.props.singleRowCheckedHandler(false);
        this.props.multipleRowCheckedHandler(false);
      }
      if (this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY) {
        this.enableBackupSummaryDelete([]);
      }
    } else {
      this.setState({
        checked: ThreeStateValue.Checked,
        checkedData: this.props.list,
      });

      if (this.props.moduleName === CONSTANTS.ALL_SAMPLES) {
        this.props.singleRowCheckedHandler(false);
        this.props.multipleRowCheckedHandler(true);
        this.checkSampleStatusForDelete(this.props.list);
      }
      if (this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY) {
        this.enableBackupSummaryDelete(this.props.list);
      }
    }
  };

  private checkSampleStatusForDelete = (checkData: any[]) => {    
    if (checkData.length === 0) {
      this.setState({
        isDisableDeleteButton: true,
        isShowWarning: false,
      });
    } else {
      const checkedStatus = checkData.filter(
        (d) =>
          d.status?.name === Status.MEASURING ||
          d.status?.name === Status.STOPPED ||
          d.status?.name === Status.PAUSED
      );
      if (checkedStatus.length > 0) {        
        this.setState({
          isDisableDeleteButton: true,
          isShowWarning: true,
        });
      } else {        
        this.setState({          
          isDisableDeleteButton: false,
          isShowWarning: false,
        });
      }
    }
  };

  private enableBackupSummaryDelete = (checkData: any[]) => {
    if (checkData.length > 0) {      
      this.setState({
        isDisableDeleteButton: false,
      });
      this.props.disableCreateButton(true);
    } else {      
      this.setState({
        isDisableDeleteButton: true,
      });
      this.props.disableCreateButton(false);
    }
  };

  private enableAction = (checkData: any[]) => {
    this.setState(
      {
        enableButton: false,
      },
      () => {
        if (checkData.length > 0) {
          this.props.EnableAction(checkData);
        }

        this.setState({
          enableButton: true,
          disableButton: true,
          checkedData: [],
          checked: 0,
        });
      }
    );
  };

  private disableAction = (checkData: any[]) => {
    this.setState(
      {
        disableButton: false,
      },
      () => {
        if (checkData.length > 0) {
          this.props.DisableAction(checkData);
        }

        this.setState({
          disableButton: true,
          enableButton: true,
          checkedData: [],
          checked: 0,
        });
      }
    );
  };

  private deleteAction = (checkData: any[]) => {        
    if (checkData.length > 0) {
      if (this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY) {
        this.props.onDeleteBackup(checkData);
      } else {
        this.setState({ deleteModalVisible: true });
      }
    }
  };

  private deleteHandler = () => {
    this.props.DeleteAction(this.state.checkedData);
    this.setState({ deleteModalVisible: false });
  }

  public render() {
    return (
      <Translation>
        {(t) => (
          <div
            className={this.props.form ? "w-100 pt-3" : "mt-3 w-100 p-3"}
            style={{
              height:
                this.props.name === CONSTANTS.LABEL_BACKUP_SUMMARY
                  ? "calc(100vh - 11rem)"
                  : null,
              background: "#F5F5F5",
            }}
          >
            {this.props.isTitle}

            {
              <div className="float-right">
                {this.props.isDisableAction ? (
                  <Authorize scopes={[`${this.props.authKey}:Disable`]}>
                    <Button
                      disabled={this.state.disableButton ? false : true}
                      sizeClass="medium"
                      type="discreet-black"
                      shape={"pill"}
                      text={t(CONSTANTS.DISABLE)}
                      icon={"abb/edit"}
                      onClick={() => this.disableAction(this.state.checkedData)}
                    />
                  </Authorize>
                ) : null}

                {this.props.isEnableAction ? (
                  <Authorize scopes={[`${this.props.authKey}:Enable`]}>
                    <Button
                      disabled={this.state.enableButton ? false : true}
                      sizeClass="medium"
                      type="discreet-black"
                      shape={"pill"}
                      text={t(CONSTANTS.ENABLE)}
                      icon={"abb/edit"}
                      onClick={() => this.enableAction(this.state.checkedData)}
                    />
                  </Authorize>
                ) : null}

                <span
                  className={
                    this.props.isDisableAction || this.props.isEnableAction
                      ? "selected-font"
                      : ""
                  }
                ></span>
                {this.props.isEditAction &&
                  this.props.moduleName !== CONSTANTS.ALL_SAMPLES ? (
                  <Authorize scopes={[`${this.props.authKey}:Edit`]}>
                    <WithTooltip>
                      <Button
                        disabled={
                          this.state.checkedData.length !==
                          ThreeStateValue.Indeterminate
                        }
                        sizeClass="medium"
                        type="discreet-black"
                        shape={"pill"}
                        className=" mr-2 icon-header"
                        icon={"abb/edit"}
                        onClick={() =>
                          this.props.editHandler(this.state.checkedData)
                        }
                      />
                      <Tooltip className="nav-tooltip">
                        <p>{t(CONSTANTS.EDIT)}</p>
                      </Tooltip>
                    </WithTooltip>
                  </Authorize>
                ) : null}                
                {this.props.isDeleteAction &&
                  this.props.moduleName !== CONSTANTS.ALL_SAMPLES &&
                  this.props.name !== CONSTANTS.LABEL_BACKUP_SUMMARY ? (
                  <Authorize scopes={[`${this.props.authKey}:Delete`]}>
                    <WithTooltip>
                      <Button                      
                        disabled={
                          this.state.checkedData.length === 0
                        }
                        sizeClass="medium"
                        type="discreet-black"
                        shape={"pill"}
                        className=" mr-2 icon-header"
                        icon={"abb/trash"}
                        onClick={() =>
                          this.deleteAction(this.state.checkedData)
                        }
                      />
                      <Tooltip className="nav-tooltip">
                        <p>{t(CONSTANTS.DELETE)}</p>
                      </Tooltip>
                    </WithTooltip>
                  </Authorize>
                ) : null}

                {this.props.moduleName === CONSTANTS.ALL_SAMPLES && (
                  <React.Fragment>
                    <span
                      className={
                        this.state.checkedData.length ? "selected-font" : ""
                      }
                    >
                      {this.props.isSingleRowChecked
                        ? `1 ${t("Selected")}`
                        : this.props.isMultipleRowChecked
                          ? `${this.state.checkedData.length}  ${t("Selected")}`
                          : null}
                    </span>
                    {this.props.isEditAction ? (
                      <Authorize scopes={[`${this.props.authKey}:Edit`]}>
                        <Button
                          sizeClass="medium"
                          type="discreet-black"
                          shape={"pill"}
                          text={t(CONSTANTS.EDIT)}
                          icon={"abb/edit"}
                        />
                      </Authorize>
                    ) : null}

                    <Authorize scopes={[`${this.props.authKey}:Export`]}>
                    <WithTooltip>
                      <Button
                        icon="abb/export"
                        sizeClass="medium"
                        type="discreet-black"
                        shape={"pill"}
                        className=" mr-2 icon-header"
                        onClick={() =>
                          this.props.isSingleRowChecked
                            ? this.props.sampleExportHandler(
                              this._currentCheckedRow
                            )
                            : this.props.sampleExportHandler(
                              this.state.checkedData
                            )
                        }
                        disabled={
                          this.props.isSingleRowChecked ||
                            this.props.isMultipleRowChecked
                            ? false
                            : true
                        }
                      />
                      <Tooltip className="nav-tooltip">
                        <p>{t("Sample")}</p>
                      </Tooltip>
                    </WithTooltip>
                    </Authorize>

                    <span className="selected-font">
                      <WithTooltip>
                        <Button
                          icon="abb/download"
                          disabled={
                            this.props.isSingleRowChecked ||
                              this.props.isMultipleRowChecked
                              ? false
                              : true
                          }
                          sizeClass="medium"
                          type="discreet-black"
                          shape={"pill"}
                          className=" mr-2 icon-header"
                          onClick={() =>
                            this.props.isSingleRowChecked
                              ? this.props.sampleDownloadHandler(
                                this._currentCheckedRow
                              )
                              : this.props.sampleExportHandler(
                                this.state.checkedData
                              )
                          }
                        />
                        <Tooltip className="nav-tooltip">
                          <p>{t(CONSTANTS.MENU_SAMPLE_MEASUREMENT)}</p>
                        </Tooltip>
                      </WithTooltip>
                    </span>

                    {this.state.checkedData.length == 0 ? (
                      <WithTooltip>
                        <Button
                          disabled={true}
                          sizeClass="medium"
                          type="discreet-black"
                          shape={"pill"}
                          icon={"abb/play"}
                          className=" mr-2 icon-header"
                          onClick={() =>
                            this.props.measurementHandler(
                              this._currentCheckedRow,
                              this.state.checkedData
                            )
                          }
                        />
                        <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                          <p>{t(CONSTANTS.BUTTON_MEASURE)}</p>
                        </Tooltip>
                      </WithTooltip>
                    ) : (
                      <WithTooltip>
                        <Button
                          disabled={
                            (this._currentCheckedRow?.status?.name ===
                              "NotMeasured" &&
                              this.props.isSingleRowChecked) ||
                              this.state.checkedData.length ===
                              this.state.checkedData.filter(
                                (d) => d.status?.name === "NotMeasured"
                              ).length
                              ? false
                              : true
                          }
                          sizeClass="medium"
                          type="discreet-black"
                          shape={"pill"}
                          icon={"abb/play"}
                          className=" mr-2 icon-header"
                          onClick={() =>
                            this.props.measurementHandler(
                              this._currentCheckedRow,
                              this.state.checkedData
                            )
                          }
                        />
                        <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                          <p>{t(CONSTANTS.BUTTON_MEASURE)}</p>
                        </Tooltip>
                      </WithTooltip>
                    )}

                    <span className="selected-font">
                      {this.state.checkedData.length == 0 ? (
                        <WithTooltip>
                          <Button
                            disabled={true}
                            sizeClass="medium"
                            type="discreet-black"
                            shape={"pill"}
                            icon={"abb/refresh"}
                            className=" mr-2 icon-header"
                            onClick={() =>
                              this.props.remeasureMeasurementHandler(
                                this._currentCheckedRow,
                                this.state.checkedData
                              )
                            }
                          />
                          <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                            <p>{t(CONSTANTS.BUTTON_REMEASURE)}</p>
                          </Tooltip>
                        </WithTooltip>
                      ) : (
                        <WithTooltip>
                          <Button
                            disabled={
                              (this._currentCheckedRow?.status?.name ===
                                "Stopped" &&
                                this.props.isSingleRowChecked) ||
                                this.state.checkedData.length ===
                                this.state.checkedData.filter(
                                  (d) => d.status?.name === "Stopped"
                                ).length
                                ? false
                                : true
                            }
                            sizeClass="medium"
                            type="discreet-black"
                            shape={"pill"}
                            icon={"abb/refresh"}
                            className=" mr-2 icon-header"
                            onClick={() =>
                              this.props.remeasureMeasurementHandler(
                                this._currentCheckedRow,
                                this.state.checkedData
                              )
                            }
                          />
                          <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                            <p>{t(CONSTANTS.BUTTON_REMEASURE)}</p>
                          </Tooltip>
                        </WithTooltip>
                      )}
                    </span>

                    {this.state.checkedData.length == 0 ? (
                      <Authorize scopes={[`${this.props.authKey}:Approve`]}>
                      <WithTooltip>
                        <Button
                          disabled={true}
                          sizeClass="medium"
                          type="discreet-black"
                          shape={"pill"}
                          icon={"abb/check-mark"}
                          className=" mr-2 icon-header"
                          onClick={() =>
                            this.props.measurementApproveHandler(
                              this._currentCheckedRow,
                              this.state.checkedData
                            )
                          }
                        />
                        <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                          <p>{t(CONSTANTS.BUTTON_APPROVE)}</p>
                        </Tooltip>
                      </WithTooltip>
                      </Authorize>
                    ) : (
                      <Authorize scopes={[`${this.props.authKey}:Approve`]}>
                      <WithTooltip>
                        <Button
                          disabled={
                            (this._currentCheckedRow?.status?.name ===
                              "Measured" &&
                              this.props.isSingleRowChecked) ||
                              this.state.checkedData.length ===
                              this.state.checkedData.filter(
                                (d) => d.status?.name === "Measured"
                              ).length
                              ? false
                              : true
                          }
                          sizeClass="medium"
                          type="discreet-black"
                          shape={"pill"}
                          icon={"abb/check-mark"}
                          className=" mr-2 icon-header"
                          onClick={() =>
                            this.props.measurementApproveHandler(
                              this._currentCheckedRow,
                              this.state.checkedData
                            )
                          }
                        />
                        <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                          <p>{t(CONSTANTS.BUTTON_APPROVE)}</p>
                        </Tooltip>
                      </WithTooltip>
                      </Authorize>
                    )}

                    <span className="selected-font">
                      {this.state.checkedData.length == 0 ? (
                        <Authorize scopes={[`${this.props.authKey}:Reject`]}>
                        <WithTooltip>
                          <Button
                            disabled={true}
                            sizeClass="medium"
                            type="discreet-black"
                            shape={"pill"}
                            icon={"abb/close"}
                            className=" mr-2 icon-header"
                            onClick={() =>
                              this.props.measurementRejectHandler(
                                this._currentCheckedRow,
                                this.state.checkedData
                              )
                            }
                          />
                          <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                            <p>{t(CONSTANTS.BUTTON_REJECT)}</p>
                          </Tooltip>
                        </WithTooltip>
                        </Authorize>
                      ) : (
                        <Authorize scopes={[`${this.props.authKey}:Reject`]}>
                        <WithTooltip>
                          <Button
                            disabled={
                              (this._currentCheckedRow?.status?.name ===
                                "Measured" &&
                                this.props.isSingleRowChecked) ||
                                this.state.checkedData.length ===
                                this.state.checkedData.filter(
                                  (d) => d.status?.name === "Measured"
                                ).length
                                ? false
                                : true
                            }
                            sizeClass="medium"
                            type="discreet-black"
                            shape={"pill"}
                            icon={"abb/close"}
                            className=" mr-2 icon-header"
                            onClick={() =>
                              this.props.measurementRejectHandler(
                                this._currentCheckedRow,
                                this.state.checkedData
                              )
                            }
                          />
                          <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                            <p>{t(CONSTANTS.BUTTON_REJECT)}</p>
                          </Tooltip>
                        </WithTooltip>
                        </Authorize>
                      )}
                    </span>
                    <Authorize scopes={[`${this.props.authKey}:Edit`]}>
                    <WithTooltip>
                      <Button
                        icon="abb/edit"
                        disabled={
                          this.props.isSingleRowChecked &&
                            this.state.checkedData[0]?.status?.name !=
                            Status.MEASURING &&
                            this.state.checkedData[0]?.status?.name !=
                            Status.STOPPED &&
                            this.state.checkedData[0]?.status?.name !=
                            Status.PAUSED
                            ? false
                            : true
                        }
                        sizeClass="medium"
                        type="discreet-black"
                        shape={"pill"}
                        className=" mr-2 icon-header"
                        onClick={() =>
                          this.props.editHandler(this._currentCheckedRow)
                        }
                      />
                      <Tooltip className="nav-tooltip">
                        <p>{t(CONSTANTS.EDIT)}</p>
                      </Tooltip>
                    </WithTooltip>
                    </Authorize>
                  </React.Fragment>
                )}

                {(this.props.moduleName === t(CONSTANTS.ALL_SAMPLES) ||
                  this.props.moduleName === CONSTANTS.LABEL_BACKUP_SUMMARY) && (
                    <React.Fragment>
                      <Authorize scopes={[`${this.props.authKey}:Delete`]}>
                        {this.state.isShowWarning ? (
                          <WithTooltip>
                            <Button
                              disabled={true}
                              sizeClass="medium"
                              type="discreet-black"
                              shape={"pill"}
                              icon={"abb/trash"}
                            />
                            <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                              <p>{t(CONSTANTS.SAMPLE_DELTE_WARNING)}</p>
                            </Tooltip>
                          </WithTooltip>
                        ) : (
                          <WithTooltip>
                            <React.Fragment>
                              <Button
                                disabled={
                                  this.state.isDisableDeleteButton ? true : false
                                }
                                sizeClass="medium"
                                type="discreet-black"
                                shape={"pill"}
                                className=" mr-2 icon-header"
                                icon={"abb/trash"}
                                onClick={() =>
                                  this.deleteAction(this.state.checkedData)
                                }
                              />
                            </React.Fragment>
                            <Tooltip className="nav-tooltip">
                              <p>{t(CONSTANTS.DELETE)}</p>
                            </Tooltip>
                          </WithTooltip>
                        )}
                      </Authorize>
                    </React.Fragment>
                  )}
                {this.props.isAssociation ? (
                  <Button
                    sizeClass="medium"
                    type="discreet-blue"
                    text={t(this.props.associationText)}
                    icon={"abb/plus"}
                    onClick={this.props.associationAction}
                  />
                ) : null}
              </div>
            }
            <div className="clearfix" />

            <hr className={this.props.view ? "hr-line ml-2" : "hr-line"} />
            {this.props.moduleName === CONSTANTS.MODULE_PROPERTY ? (
              <React.Fragment>
                <div>
                  <span>{t(CONSTANTS.FORMULA)}:</span>
                </div>
                <div>
                  <span>{t(CONSTANTS.INPUT_DEFINITION)}:</span>
                </div>
              </React.Fragment>
            ) : null}
            <div className="abb-wrapper">
              <div
                className={
                  this.props.isFixedColumn
                    ? "abb-column-scroller"
                    : "abb-scroller fixed-table-position"
                }
                id="scrollableDiv"
              >
                <table
                  className={
                    this.props.isFixedColumn
                      ? "abb-table table-fixed "
                      : `abb-table w-100 ${this.props.isRowClass}`
                  }
                >
                  <thead
                    className={this.props.isFixedColumn ? "" : "sticky-table"}
                  >
                    {this.state.isToggleEnable && (
                      <div className="overlap-div">&nbsp;</div>
                    )}
                    <tr>{this.renderTableHeadData()}</tr>
                    <tr
                      style={{
                        display: this.state.isToggleEnable ? "" : "none",
                      }}
                    >
                      {this.filterTableHeadData()}
                    </tr>
                  </thead>
                  <tbody>{this.renderTableData()}</tbody>
                </table>
                {this.props.list?.length === 0 && (
                  <div className="text-center no-data-search-view-all">
                    <b>{t(CONSTANTS.NO_DATA_MESSAGE)}</b>
                  </div>
                )}
              </div>
            </div>
            
            <Dialog
              isOpen={this.state.deleteModalVisible}
              onClose={() => this.setState({ deleteModalVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.DELETE_TITLE, {
                name: CONSTANTS.BUTTON_CONFIRM,
              })}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: () => this.deleteHandler(),
                },
              ]}
            >
              <div className="delete-popup-text-overflow-hidden">
                {t(CONSTANTS.DELETE_MESSAGE, {
                  module: t(this.props.deleteModuleName),
                })}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.DELETE_POPUP_MESSAGE)}
              </div>
            </Dialog>
            <div className="clearfix" />
          </div>
        )}
      </Translation>
    );
  }
}
